const Asian_3=[
    {
        "Name": "Chr01",
        "Length": 217540000
    },
    {
        "Name": "Chr02",
        "Length": 114577180
    },
    {
        "Name": "Chr03",
        "Length": 111386608
    },
    {
        "Name": "Chr04",
        "Length": 97559953
    },
    {
        "Name": "Chr05",
        "Length": 85641709
    },
    {
        "Name": "Chr06",
        "Length": 68621336
    },
    {
        "Name": "Chr07",
        "Length": 61012511
    },
    {
        "Name": "Chr08",
        "Length": 58881387
    }
]
export default Asian_3